import React from "react";

export default function DropDownItem(props) {
  return (
    <li>
      <span className="dropdown-item" {...props} />
    </li>
  );
}
